import { createFileRoute } from '@tanstack/react-router'

import { PrivacyPanel } from '@/features/user/profile'

export const Route = createFileRoute('/_event/minha-conta/privacidade')({
  component: PrivacyPanel
})
